import axios from 'axios';
import { API_URL } from '../constant';

const API_BASE_URL = API_URL || 'https://staging.api.topcoinuk.com/api';

// Create axios instance with auth headers
const api = axios.create({
  baseURL: API_BASE_URL,
});

// Add token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('auth_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const memberService = {
  // Get all members with pagination and filters
  getAllmembers: async (params = {}) => {
    const response = await api.get('/superadmin/members', { params });
    return response.data;
  },

  // Get specific member details
  getMember: async (userId) => {
    const response = await api.get(`/superadmin/members/${userId}`);
    return response.data;
  },

  // Create new member
  createMember: async (memberData) => {
    const response = await api.post('/superadmin/members', memberData);
    return response.data;
  },

  // Update member
  updateMember: async (userId, memberData) => {
    const response = await api.put(`/superadmin/members/${userId}`, memberData);
    return response.data;
  },

  // Delete member
  deleteMember: async (userId) => {
    const response = await api.delete(`/superadmin/members/${userId}`);
    return response.data;
  },

  // Update member status
  updateMemberStatus: async (userId, statusData) => {
    const response = await api.post(`/superadmin/members/${userId}/status`, statusData);
    return response.data;
  },

  // Get member status history
  getMemberStatusHistory: async (userId) => {
    const response = await api.get(`/superadmin/members/${userId}/status-history`);
    return response.data;
  },

  // Get member wallet details
  getMemberWallet: async (userId) => {
    const response = await api.get(`/superadmin/members/${userId}/wallet`);
    return response.data;
  },

  // Reset member password
  resetMemberPassword: async (userId, passwordData) => {
    const response = await api.post(`/superadmin/members/${userId}/reset-password`, passwordData);
    return response.data;
  },

   getMemberTransactionHistory: async (memberId, params = {}) => {
    try {
      const response = await api.get(`/superadmin/members/${memberId}/transaction-history`, { params });
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  checkEmailAvailability: async (email) => {
    try {
      const response = await api.post('/superadmin/members/check-email-availability', { email });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getMemberCount: async (filters = {}) => {
    try {
      const response = await api.get('/superadmin/count/members', {
        params: filters,
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching member count:', error);
      throw error;
    }
  }

};